module.exports = __webpack_public_path__ + "static/img/142.2103b8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/142.png
// module id = tv+u
// module chunks = 0